import { render, staticRenderFns } from "./StudentGoodsCategory.vue?vue&type=template&id=071b4fdc&scoped=true&"
import script from "./StudentGoodsCategory.vue?vue&type=script&lang=js&"
export * from "./StudentGoodsCategory.vue?vue&type=script&lang=js&"
import style0 from "./StudentGoodsCategory.vue?vue&type=style&index=0&id=071b4fdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071b4fdc",
  null
  
)

export default component.exports